import { GlobalSearch } from "@/features/search/components/global-search";

/** `/search` — firm-wide global search across clients, records, team, and KB. */
export default function SearchPage() {
  return <GlobalSearch />;
}
